import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from "@angular/router";
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { PrimeIcons } from 'primeng/api';
import { LocationFrom, LocationTO, PartsMovementSaveRequest, StockType } from 'src/app/wings-mobile/models/part-movement/parts-movement-save-request.model';
import { PartsMovementSearchRequest } from 'src/app/wings-mobile/models/part-movement/parts-movement-search-request.model';
import { PartsMovementSearchResponse } from 'src/app/wings-mobile/models/part-movement/parts-movement-search-response.model';
import { PartsMovementService } from 'src/app/wings-mobile/services/inbound/parts-movement.service';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { InputFields } from "../../../../models/inputs/input-fields.model";
import { Globals } from '../../../../shared/globals/globals';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { InputGenericComponent } from '../../../../shared/input-generic/input-generic.component';
import { StockPickComponent } from '../stock-pick/stock-pick.component';
import { AlertCustomComponent } from '../../../../shared/alert-custom/alert-custom.component';

@Component({
    selector: 'parts-movement',
    templateUrl: './parts-movement.component.html',
    styleUrls: ['./parts-movement.component.css'],
    imports: [FormsModule, InputTextModule, NgClass, NgIf, ButtonDirective, InputGenericComponent, StockPickComponent, AlertCustomComponent, TranslatePipe]
})
export class PartsMovementComponent implements OnInit {

	partMovementRequest: PartsMovementSearchRequest;
	partMovementResponse: PartsMovementSearchResponse[];
	partsMovementSaveRequest: PartsMovementSaveRequest = new PartsMovementSaveRequest();
	locationFrom: LocationFrom;
	oldLocation: LocationFrom;
	locationSugestionForPart: string;
	locationTo: LocationTO;
	stockType: StockType = {};

	showPartInputs: boolean;
	showLabelText: boolean;
	pendingMovement: boolean;
	showAlert: boolean = false;
	showStockPickModal: boolean = false;

	typeSearch: string;

	errorTitle: string;
	errorMessage: string;
	errorFocus: string;

	inputFields: InputFields[];

	events: any[];

	constructor(
		public globals: Globals,
		private beep: MessageBeep,
		private partsMovementService: PartsMovementService,
		private renderer: Renderer2,
		private translate: TranslateService,
		private route: Router
	) {
		this.renderer = renderer;
		this.globals = globals;
		this.partsMovementService = partsMovementService;
		this.beep = beep;
		this.translate = translate;
		this.route = route;
		this.inputFields = [
			{ name: 'label_part', id: 'label_part', focus: true, value: null, action: 'this.checkLabelPart()', valid: false },
			{ name: 'location_from', id: 'location_from', focus: false, value: null, action: 'this.checkLocationFrom()', valid: false },
			{ name: 'quantity_from', id: 'quantity_from', focus: false, value: null, action: '', valid: false },
			{ name: 'location_to', id: 'location_to', focus: false, value: null, action: 'this.checkLocationTo()', valid: false },
			{ name: 'quantity_to', id: 'quantity_to', focus: false, value: null, action: 'this.checkQuantityTo()', valid: false }
		];
	}

	ngOnInit() {
		this.events = [
			{ status: 'Ordered', date: '15/10/2020 10:30', icon: PrimeIcons.SHOPPING_CART, color: '#9C27B0', image: 'game-controller.jpg' },
			{ status: 'Processing', date: '15/10/2020 14:00', icon: PrimeIcons.COG, color: '#673AB7' },
			{ status: 'Shipped', date: '15/10/2020 16:15', icon: PrimeIcons.ENVELOPE, color: '#FF9800' },
			{ status: 'Delivered', date: '16/10/2020 10:00', icon: PrimeIcons.CHECK, color: '#607D8B' }
		];

		this.showLabelText = false;
		this.showPartInputs = false;
		this.oldLocation = JSON.parse(localStorage.getItem('oldLocation'));
		this.locationFrom = this.oldLocation;
		this.checkPendingMovement();
	}

	checkLabelPart() {
		this.renderer.selectRootElement(`#label_part`).blur();
		isNaN(Number(this.inputFields[0].value)) ? this.setPartInformation() : this.setLabelInformation();
		this.inputFields[3].value = null;
		if (this.canSendRequest()) {
			this.partsMovementService.postSearch(this.partMovementRequest).subscribe(res => {
				this.partMovementResponse = res;
				if (this.partMovementRequest.label) {
					this.typeSearch = 'label';
					this.locationFrom = res[0];
					this.checkErrorOnLabel();
				} else {
					const popimsCode = res[0].bkGspnPrefixC + res[0].bkGspnBaseC + res[0].bkGspnSuffixC;
					this.typeSearch = 'part';
					this.getLocationSugestionForPart(this.globals.user.warehouse.warehouseUidK, popimsCode);
					this.checkErrorOnPart();
				}
			})
		}
		this.inputFields[1].value = null;
		this.inputFields[2].value = null;
		this.inputFields[4].value = null;
		this.showLabelText = false;
		this.showPartInputs = false;
	}

	getLocationSugestionForPart(bkWarehouseCode: number, popimsCode: string) {
		this.partsMovementService.findLocationSugestionForPart(bkWarehouseCode, popimsCode).subscribe(data => {
			this.locationSugestionForPart = data;
			this.inputFields[3].value = data;
		});
	}

	checkLocationFrom() {
		this.chackNameLocation(1);
		this.setInputToInvalid('location_from');
		this.locationFrom = this.partMovementResponse.find(part => part.bkLocationC.toUpperCase() === this.inputFields[1].value.toUpperCase());
		if (this.locationFrom) {
			this.isLocationMobile('location_from');
		} else {
			if (this.inputFields[1].value) {
				this.partsMovementService.findByLocation(this.inputFields[1].value, this.globals.user.warehouse.warehouseUidK)
					.subscribe(res => {
						if (res) {
							this.callFindByMovement();
						} else {
							this.showErrorModal('modal.error', 'modal.locationNotFound', 'location_from');
						}
					})
			}
		}
	}

	checkQuantityFrom() {
		if (this.inputFields[2].value != null) {
			if (this.inputFields[2].value <= 0) {
				this.inputFields[2].value = null;
				this.beep.showAlertCustom('modal.error', 'modal.quantityLessOrEqualToZero', 'quantity_from');
			} else if (this.inputFields[2].value > this.locationFrom.freeStock) {
				this.inputFields[2].value = null;
				this.beep.showAlertCustom('modal.error', 'modal.quantityGreaterThanLocation', 'quantity_from');
			} else {
				this.inputFields[2].valid = true;
				this.moveToUserId();
			}
		}
		this.blurInputFields('quantity_from');
	}

	checkLocationTo() {
		this.inputFields[3].value = this.inputFields[3].value.toUpperCase();
		this.chackNameLocation(3);
		this.setInputToInvalid('location_to');
		if (this.inputFields[3].value) {
			if (this.checkLocationValid()) {
				this.callFindByLocation();
			}
		}
	}

	checkQuantityTo() {
		if (this.typeSearch === 'part') {
			if (this.inputFields[4].value <= 0 ||
				this.inputFields[4].value > this.inputFields[2].value) {
				this.beep.showAlertCustom('modal.error', 'modal.invalidAmount');
				this.inputFields[4].value = null;
				this.setInputToInvalid('quantity_to');
			} else {
				this.inputFields[4].valid = true;
			}
		} else {
			if (this.inputFields[4].value <= 0 ||
				this.inputFields[4].value > this.locationFrom.freeStock) {
				this.beep.showAlertCustom('modal.error', 'modal.invalidAmount');
				this.inputFields[4].value = null;
				this.setInputToInvalid('quantity_to');
			} else {
				this.inputFields[4].valid = true;
			}
		}
	}

	setPartInformation() {
		this.partMovementRequest = {
			typeSearch: 'part',
			bkWarehouse: this.globals.user.warehouse.warehouseUidK
		};

		this.setPartCountryInformation();

		if (this.inputFields[0].value) {
			this.partMovementRequest.typePart = 'POP';
		}
	}

	setLabelInformation() {
		this.partMovementRequest = {
			typeSearch: 'label',
			bkWarehouse: this.globals.user.warehouse.warehouseUidK,
			label: this.inputFields[0].value
		};
	}

	canSendRequest(): boolean {
		if (this.inputFields[0].value) {
			if (this.typeSearch === 'part') {
				if (this.inputFields[0].value.length <= 2) {
					return false;
				}
				return true;
			}
			return true;
		}
		return false
	}

	setPartCountryInformation() {
		switch (this.globals.user.country) {
			case 'BRA':
				this.partMovementRequest.popimsArgBraC = this.inputFields[0].value;
				break;
			case 'ARG':
				this.partMovementRequest.popimsArgBraC = this.inputFields[0].value;
				break;
			case 'PER':
				this.partMovementRequest.popimsPer = this.inputFields[0].value;
				break;
			case 'CHL':
				this.partMovementRequest.popimsChl = this.inputFields[0].value;
				break;
			case 'COL':
				if (this.inputFields[0].value.includes('/')) {
					this.partMovementRequest.popimsArgBraC = this.inputFields[0].value;
				} else {
					this.partMovementRequest.perfitSerial = this.inputFields[0].value;
				}
				break;
			default:
				this.resetOnErrorLabelPart('modal.CountryNotFound');
				this.focusInputFields('label_part', true);
				break;
		}
	}

	getPartsMovementService() {
		this.partsMovementService.postSearch(this.partMovementRequest).subscribe(res => {
			this.partMovementResponse = res;
			if (this.partMovementResponse.length === 0) {
				this.resetOnErrorLabelPart('modal.labelAndPartNotFound');
			} else {
				this.beep.successBeep();
				this.showLabelText = false;
				this.showPartInputs = true;
				this.inputFields[0].valid = true;
			}
		})
	}

	checkErrorOnLabel() {
		if (this.partMovementResponse.length === 0) {
			this.checkColombia();
		} else {
			this.checkLabelIsReceiving();
		}
	}

	checkErrorOnPart() {
		if (this.partMovementResponse.length === 0) {
			this.resetOnErrorLabelPart('modal.partNotFound');
		} else {
			this.beep.successBeep();
			this.showLabelText = false;
			this.showPartInputs = true;
			this.focusInputFields('location_from', true);
			this.inputFields[0].valid = true;
		}
	}

	checkLabelIsReceiving() {
		this.locationFrom = this.partMovementResponse.find(obj => obj.bkStockTypeC === '9');
		if (this.locationFrom) {
			this.beep.successBeep();
			this.oldLocation = this.locationFrom;
			this.oldLocation.typeSearch = this.typeSearch;
			this.oldLocation.label = this.inputFields[0].value;
			localStorage.setItem('oldLocation', JSON.stringify(this.oldLocation));
			this.inputFields[0].valid = true;
			this.inputFields[1].valid = true;
			this.inputFields[2].valid = true;
			this.showPartInputs = false;
			this.showLabelText = true;
			this.blurInputFields('all');
			this.moveToUserId();
		} else {
			this.resetOnErrorLabelPart('modal.labelNotReceiving');
		}
	}

	checkColombia() {
		if (this.globals.user.country === 'COL') {
			this.setPartInformation();
			this.getPartsMovementService();
		} else {
			this.resetOnErrorLabelPart('modal.labelNotFound');
		}
	}

	resetOnErrorLabelPart(errorMsg: string = 'Error Ocurred') {
		this.showPartInputs = false;
		this.showLabelText = false;
		this.showErrorModal('modal.error', errorMsg, 'label_part')
		this.setInputToInvalid('label_part');
	}

	callFindByMovement() {
		this.partsMovementService.findByMovement(this.inputFields[1].value, this.globals.user.warehouse.warehouseUidK, this.partMovementResponse[0].bkPartWhUidD)
			.subscribe(res => {
				if (res.length === 0) {
					this.showErrorModal('modal.error', 'modal.partLocationNotFound', 'location_from');
				} else {
					this.beep.successBeep();
					this.locationFrom = res[0];
					this.isLocationMobile('locationFrom');
				}
			})
	}

	callFindByLocation() {
		this.partsMovementService.findByLocation(this.inputFields[3].value, this.globals.user.warehouse.warehouseUidK)
			.subscribe({
				next: (res) => {
					if (res) {
						this.locationTo = res;
						this.findStockType(this.inputFields[3].value, this.inputFields[3].id);
					} else {
						this.showErrorModal('modal.error', 'modal.locationNotFound', 'location_to');
					}
				},
				error: () => {
					this.beep.showAlertCustom('modal.error', 'modal.connectionFailed', 'location_to');
				}
			});
	}

	moveToUserId() {
		if (this.inputFields[2].valid && !this.pendingMovement) {
			this.stockType.stockTypeC = 'Q';
			this.stockType.stockType = 'Q - OTHERS LOCATION';

			if (this.typeSearch === 'part') {
				if (!this.inputFields[2].value) {
					this.beep.showAlertCustom('modal.error', 'modal.invalidAmount', 'quantity_from');
					this.inputFields[2].valid = false;
				}
			}
			if (this.locationFrom.bkLocationC) {
				this.postMoveLocation();
				this.inputFields[3].valid = true;
			}
		}
	}

	checkLocationValid(): boolean {
		let isValid = true;
		if (this.inputFields[3].value.toUpperCase() === this.inputFields[1].value.toUpperCase()) {
			this.showErrorModal('modal.error', 'modal.moveSameLocation', 'location_to');
			isValid = false;
		}
		return isValid;
	}

	isLocationMobile(methodLocation: string) {
		if (methodLocation === 'location_to') {
			if (this.locationTo.bkWhLocationTypeUidD === 59) {
				this.showErrorModal('modal.error', 'modal.moveToUser', 'location_to');
			}
		} else {
			if (this.locationFrom.bkWhLocationTypeUidD === 59) {
				this.showErrorModal('modal.error', 'modal.moveToUser', 'location_from');
			} else {
				this.focusInputFields('quantity_from');
				this.inputFields[1].valid = true;
				this.oldLocation = this.locationFrom;
				this.oldLocation.typeSearch = this.typeSearch;
				this.oldLocation.label = this.inputFields[0].value;
				localStorage.setItem('oldLocation', JSON.stringify(this.oldLocation));
			}
		}
	}

	findStockType(location: string, elFocus: string) {
		this.isLocationMobile(elFocus);
		if (this.locationTo.bkLocationTypeC === 'STAGING') {
			let location: PartsMovementSearchResponse = {
				bkWhLocationUidD: 17,
				bkStockTypeC: '9',
				stockTypeN: 'RECEIPT LOCATION',
			}
			this.setStockType(location);
			this.inputFields[3].valid = true;
		} else {
			let request: PartsMovementSearchRequest = {
				bkLocation: location,
				typeSearch: 'location',
				bkWarehouse: this.globals.user.warehouse.warehouseUidK
			}
			this.partsMovementService.postSearch(request).subscribe(res => {
				let response: PartsMovementSearchResponse[] = res;
				let responseFilter = response.find(part => part.bkPartWhUidD === this.locationFrom.bkPartWhUidD);
				if (responseFilter) {
					this.setStockType(responseFilter);
					this.beep.successBeep();
				} else {
					if (this.locationTo.bkWhLocationTypeUidD !== 59) {
						this.showStockPickModal = true;
					}
				}
				this.focusInputFields('quantity_to');
				this.inputFields[3].valid = true;
			})
		}
	}

	setStockType(response: PartsMovementSearchResponse = null) {
		this.stockType = {
			stockTypeC: response.bkStockTypeC,
			stockType: response.bkStockTypeC + ' - ' + response.stockTypeN
		}
	}

	postMoveLocation() {
		this.partsMovementSaveRequest = {};
		this.partsMovementSaveRequest.user = {};
		this.partsMovementSaveRequest.locationFrom = {};
		this.partsMovementSaveRequest.locationTO = {};
		this.partsMovementSaveRequest.stockType = {};

		this.partsMovementSaveRequest.requestType = 'MOBILE';

		this.partsMovementSaveRequest.user.subDivisionUidK = this.globals.user.warehouse.bkSubDivisionUidD;
		this.partsMovementSaveRequest.user.userId = this.globals.user.userName;
		this.partsMovementSaveRequest.user.language = this.globals.user.language;
		this.partsMovementSaveRequest.user.country = this.globals.user.country;
		this.partsMovementSaveRequest.user.bkSubDivisionC = 'FRD';

		this.partsMovementSaveRequest.warehouseUidK = this.globals.user.warehouse.warehouseUidK;

		this.partsMovementSaveRequest.locationFrom = this.locationFrom;
		if (!this.checkDisableButton()) {
			this.partsMovementSaveRequest.locationFrom.bkLocationC = this.globals.user.userName;
		}
		this.partsMovementSaveRequest.locationTO.bkLocationC = this.checkDisableButton() ? this.globals.user.userName : this.inputFields[3].value;

		this.partsMovementSaveRequest.locationTO.bkLocationTypeC = this.checkDisableButton() ? "MOBILE" : this.locationTo.bkLocationTypeC;

		this.partsMovementSaveRequest.saldoTO = this.checkDisableButton() ? this.checkType() : this.inputFields[4].value;

		this.partsMovementSaveRequest.stockType = this.stockType;

		this.partsMovementSaveRequest.typeSearch = this.checkDisableButton() ? this.typeSearch : "part";

		this.partsMovementSaveRequest.label = this.oldLocation.label;

		this.partsMovementSaveRequest.language = this.globals.user.language;

		this.partsMovementService.postMoveLocation(this.partsMovementSaveRequest).subscribe({
			next: () => {
				if (this.typeSearch === 'part') {
					if (this.partsMovementSaveRequest.locationFrom.currentQ - this.partsMovementSaveRequest.saldoTO === 0) {
						this.beep.successBeep();
					}
				} else {
					if (this.partsMovementSaveRequest.locationFrom.freeStock - this.partsMovementSaveRequest.saldoTO === 0) {
						this.beep.successBeep();
					}
				}
				this.partsMovementSaveRequest = null;
				this.ngOnInit();
			},
			error: (error) => {
				let messageError: string = 'modal.operationNotPerformed';

				this.partsMovementSaveRequest = null;
				if (this.checkDisableButton()) {
					this.inputFields[2].valid = false;
				} else {
					this.inputFields[4].valid = false;
				}

				switch (error.error) {
					case "partNotFound":
						messageError = 'modal.partNotFound';
						break;
					case "sameLocation":
						messageError = 'modal.moveSameLocation';
						break;
					case "cantMoveToLostLocation":
						messageError = 'modal.cantMoveToLostLocation';
						break;
					case "cantMoveToMobileLocation":
						messageError = 'modal.cantMoveToMobileLocation';
						break;
					case "cantMoveUncheckedLabelToNonstageLocation":
						messageError = 'modal.cantMoveUncheckedLabelToNonstageLocation';
						break;
					case "saldoTOLessThanZero":
						messageError = 'modal.saldoTOLessThanZero';
						break;
					case "partNotActive":
						messageError = 'modal.partNotActive';
						break;
					case "notEnableOrderingF":
						messageError = 'modal.notEnableOrderingF';
						break;
					case "notEnableForReceivingF":
						messageError = 'modal.notEnableForReceivingF';
						break;
					case "warehouseXPartsXLocationNotFound":
						messageError = 'modal.warehouseXPartsXLocationNotFound';
						break;
					case "warehouseXPartsXLocationDenial":
						messageError = 'modal.warehouseXPartsXLocationDenial';
						break;
					case "stockTypeToNotFound":
						messageError = 'modal.stockTypeToNotFound';
						break;
					case "locationToNotFound":
						messageError = 'modal.locationToNotFound';
						break;
					case "cantMoveToLostLocation":
						messageError = 'modal.cantMoveToLostLocation';
						break;
					case "insufficientBalanceFROM":
						messageError = 'modal.insufficientBalanceFROM';
						break;
					case "invalidHash":
						messageError = 'modal.invalidHash';
						break;
				}

				this.beep.showAlertCustom('modal.error', messageError, 'quantity_from');
			}
		})
	}

	checkType() {
		return this.typeSearch === 'part' ? this.inputFields[2].value : this.locationFrom.freeStock;
	}

	setInputToInvalid(elId: string) {
		switch (elId) {
			case 'label_part':
				this.inputFields[0].valid = false;
				this.inputFields[1].value = null;
				this.inputFields[2].value = null;
				this.inputFields[3].value = null;
				this.inputFields[4].value = null;
				this.locationFrom = null;
				this.showLabelText = false;
				this.showPartInputs = false;
				break;
			case 'location_from':
				this.inputFields[1].valid = false;
				this.inputFields[2].value = null;
				this.inputFields[3].value = null;
				this.inputFields[4].value = null;
				this.locationFrom = null;
				break;
			case 'quantity_from':
				this.inputFields[2].valid = false;
				this.inputFields[3].valid = false;
				break;
			case 'location_to':
				this.inputFields[3].valid = false;
				this.inputFields[4].valid = false;
				this.inputFields[4].value = null;
				break;
			case 'quantity_to':
				this.inputFields[4].valid = false;
				break;
			case 'all':
				this.inputFields.forEach(input => input.valid = false);
			default:
				break;
		}
	}

	focusInputFields(elId: string = 'remove', focusZebra: boolean = false) {
		this.blurInputFields('all');

		if (focusZebra) {
			this.renderer.selectRootElement('#scanner_id').focus();
		} else {
			if (elId !== 'remove') {
				this.renderer.selectRootElement(`#${elId}`).focus();
			}
		}

		switch (elId) {
			case 'label_part':
				this.inputFields[0].focus = true;
				break;
			case 'location_from':
				this.inputFields[1].focus = true;
				break;
			case 'quantity_from':
				this.inputFields[2].focus = true;
				break;
			case 'location_to':
				this.inputFields[3].focus = this.inputFields[2].valid ? true : false;
				break;
			case 'quantity_to':
				this.inputFields[4].focus = true;
				break;
			default:
				break;
		}
	}

	blurInputFields(elId: string = 'all') {
		switch (elId) {
			case 'label_part':
				this.inputFields[0].focus = false;
				break;
			case 'location_from':
				this.inputFields[1].focus = false;
				break;
			case 'quantity_from':
				this.inputFields[2].focus = false;
				break;
			case 'location_to':
				this.inputFields[3].focus = false;
				break;
			case 'quantity_to':
				this.inputFields[4].focus = false;
				break;
			default:
				this.inputFields.forEach(input => input.focus = false);
				break;
		}
	}

	chosenValueStockTypeUidK(stock: StockType) {
		this.stockType = stock;
		this.showStockPickModal = false;
		this.focusInputFields('quantity_to');
	}

	executeAction(item) {
		eval(item.action);
	}

	showErrorModal(title: string, msg: string, focus?: string) {
		this.errorTitle = this.translate.instant(title);
		this.errorMessage = this.translate.instant(msg);
		this.errorFocus = focus;
		this.showAlert = true;
		this.beep.errorBeep();
	}

	hideErrorModal(elId: string) {
		if (elId) {
			this.focusInputFields(elId, true);
		}
		this.setInputToInvalid(elId);
		this.inputFields.forEach(item => {
			if (item.id === elId) {
				item.value = null;
			}
		});
		this.showAlert = false;
	}

	checkDisableButton(): boolean {
		let disable = false;
		this.inputFields.forEach(input => {
			if (this.typeSearch === 'part') {
				if (!input.valid) {
					disable = true;
				}
			} else {
				if (input.id !== 'location_from' && input.id !== 'quantity_from') {
					if (!input.valid) {
						disable = true;
					}
				}
			}
		});
		return disable;
	}

	checkPendingMovement() {
		setTimeout(() => {
			let pendingMovementRequest: PartsMovementSearchRequest = {
				bkLocation: this.globals.tokenData.uid,
				typeSearch: 'location',
				bkWarehouse: this.globals.user.warehouse.warehouseUidK
			}
			this.partsMovementService.postSearch(pendingMovementRequest).subscribe({
				next: (res) => {
					this.inputFields.forEach(input => input.value = null);
					if (res.length !== 0) {
						this.locationFrom = res.find(part => part.freeStock > 0);
						if (this.locationFrom) {
							this.partMovementResponse = res;
							this.showErrorModal('modal.error', 'modal.endOperation', 'location_to');
							this.disableOnPendingMovement();
						} else {
							this.enableOnPendingMovement();
						}
					} else {
						this.enableOnPendingMovement()
					}
				},
				error: () => {
					this.showErrorModal('modal.error', 'modal.endOperation');
					this.route.navigate(['inbound'])
				}
			})
		}, 1000);
	}

	// When user HAS a pending movement
	disableOnPendingMovement() {
		this.setDisabledInputs();
		this.pendingMovement = true;
		this.showPartInputs = true;
		this.showLabelText = false;
		this.typeSearch = this.oldLocation.typeSearch;
	}

	setDisabledInputs() {
		let partName = this.locationFrom.bkGspnPrefixC + '/' + this.locationFrom.bkGspnBaseC + '/' + this.locationFrom.bkGspnSuffixC;
		this.inputFields[0].value = partName;
		this.inputFields[1].value = this.oldLocation.bkLocationC;
		this.inputFields[2].value = this.typeSearch === 'part' ? this.locationFrom.currentQ : this.locationFrom.freeStock;
		this.inputFields[3].value = null;
		this.inputFields[4].value = null;

		this.inputFields[0].valid = true;
		this.inputFields[1].valid = true;
		this.inputFields[2].valid = true;
		this.inputFields[3].valid = false;
		this.inputFields[4].valid = false;
	}

	chackNameLocation(position: number) {
		this.inputFields[position].value = this.inputFields[position].value.replaceAll(' ', '');
		this.inputFields[position].value = this.inputFields[position].value.replaceAll('*', '');
	}

	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	enableOnPendingMovement() {
		this.pendingMovement = false;
		this.setInputToInvalid('all');
		this.focusInputFields('label_part', true);
	}

	getSuggestionAndFocus() {
		const partCode = this.locationFrom.bkGspnPrefixC + this.locationFrom.bkGspnBaseC + this.locationFrom.bkGspnSuffixC;
		this.focusInputFields('location_to');
		this.getLocationSugestionForPart(this.globals.user.warehouse.warehouseUidK, partCode);
	}
}

